var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbSelect',{class:_vm.baseClass,attrs:{"value":_vm.selectedQuery,"options":_vm.queries,"disabled":_vm.disabled || _vm.queries.length < _vm.MIN_QUERIES_TO_BE_ENABLED,"placeholder":_vm.placeholder,"round":_vm.round,"data-test":"ui-select","required":""},on:{"input":_vm.selectQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }